import { Add, Search } from '@mui/icons-material';
import {
	Container,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from '@mui/material';
import { Placeholder, SortableTableHeader, Subheader } from 'components';
import { useNavigation } from 'hooks';
import EarnItem from './EarnItem';
import useEarnItems from 'hooks/useEarnItems';
import { useEffect } from 'react';
import CoinRateItem from './CoinRateItem';
import useCoinRate from 'hooks/useCoinRate';

const TABLE_HEADERS = [
	{
		value: 'name',
		label: 'Name',
		sortable: false,
		hidden: false
	},

	{
		value: 'coins',
		label: 'Coins',
		sortable: false,
		hidden: false
	},
	{
		value: 'xp',
		label: 'XP',
		sortable: false,
		hidden: false
	}
];
const demoCoinRates = [
	{
		name: 'Default',
		coins: 10,
		xp: 5,
		id: 1
	},
	{
		name: 'Double Coins',
		coins: 20,
		xp: 5,
		id: 2
	}
];

const CoinRateList = () => {
	const { coinRates, isLoading, findCoinRates } = useCoinRate();

	const { handleClick, handleEditClick, handleAddClick } = useNavigation({
		history,
		url: '/coin-rates'
	});

	useEffect(() => {
		findCoinRates();
	}, []);

	return (
		<>
			<Subheader title="Coin Rates" buttons={[]} />

			<Container maxWidth="lg">
				{!isLoading && coinRates.length > 0 ? (
					<TableContainer component={Paper} elevation={0}>
						<Table>
							<TableHead>
								<TableRow>
									{TABLE_HEADERS.filter((h) => !h.hidden).map((header, idx) => (
										<SortableTableHeader
											key={idx}
											handleSort={() => {}}
											value={`coin-rates.${header.value}`}
											sortable={header.sortable}
											sortKey={''}
											sortDirection={''}
										>
											{header.label}
										</SortableTableHeader>
									))}
									<TableCell></TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{coinRates.map((coinRate, idx) => (
									<CoinRateItem
										key={idx}
										coinRate={coinRate}
										handleClick={handleClick}
										handleDeleteClick={() => {}}
										handleEditClick={handleEditClick}
									/>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				) : (
					<Placeholder
						icon={<Search />}
						title="No Coin Rates"
						subtitle="Please try again"
					/>
				)}
			</Container>
		</>
	);
};

export default CoinRateList;
